import { Producto } from './Producto';
import { Contenedor } from './Contenedor';
import { TanqueGeneral } from './TanqueGeneral';

export class GrupoDeTanques extends TanqueGeneral{
    tanques: TanqueGeneral[];
}